export const LINK_SORTING_MAP: Record<string, string> = {
  playerLink: 'player.displayName',
  teamLink: 'team.name',
  recipientPlayerLink: 'recipientPlayer.displayName',
  currentTeam: 'currentTeam.name',
};

// Keys that only exist after client-side enrichment and have no server-side column equivalent.
// Promoting these to serverOrderByAtom would send an invalid order_by param to the API.
export const CLIENT_ONLY_SORT_KEYS: ReadonlySet<string> = new Set([LINK_SORTING_MAP.currentTeam]);
